import {
  createWrapper,
  type AnyAnalytics
} from "@segment/analytics-consent-tools"
import { type InitOptions } from "@segment/analytics-next"
import { analytics } from "lib/segment"
import { SEGMENT_ID } from "lib/environment"
import { FeatureFlagReadModel, FeatureFlagReadModelFactory } from "featureFlags"
import { consentBus } from "cookiesConsent/infrastructure/segment/ConsentBus"
import { SegmentConsentSettings } from "cookiesConsent/infrastructure/segment/SegmentConsentSettings"

const deferredLoadOptions: InitOptions = {
  storage: { stores: [`localStorage`, `memory`] }
}

const keptAliveLoadOptions: InitOptions = {
  storage: { stores: [`localStorage`, `memory`] },
  integrations: {
    "Segment.io": {
      deliveryStrategy: {
        strategy: `standard`,
        config: { keepalive: true }
      }
    }
  }
}

class SegmentLoadOptionsFactory {
  private readonly featureFlags: FeatureFlagReadModel

  constructor(featureFlags: FeatureFlagReadModel) {
    this.featureFlags = featureFlags
  }

  build = (): InitOptions => {
    if (
      this.featureFlags
        .getByName(`ENABLE_CHECKOUT_PAYMENT_EVENTS_WEB_5096`)
        .isEnabled()
    ) {
      return keptAliveLoadOptions
    } else {
      return deferredLoadOptions
    }
  }
}

export const exposeAnalyticsBuffer = (): void => {
  window.analytics = analytics
}

export const startDeferredSegment = (
  featureFlags: FeatureFlagReadModel = new FeatureFlagReadModelFactory().build()
): void => {
  createWrapper<AnyAnalytics>(new SegmentConsentSettings(consentBus))(
    analytics as unknown as AnyAnalytics
  )

  analytics.load(
    { writeKey: SEGMENT_ID },
    new SegmentLoadOptionsFactory(featureFlags).build()
  )
}
